<template>
  <v-dialog persistent width="450" v-model="dialogOpen">
    <v-card>
      <v-card-title>Lead Source</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete v-model="lead_source" label="Lead Source" :items="getLeadSources" :error-messages="leadSourceErrors" :hide-details="leadSourceErrors.length===0" @change="$v.lead_source.$touch()" @blur="$v.lead_source.$touch()" :disabled="formLoading||!hasUserGotRole('marketing-team')" outlined dense required></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete v-model="channel" label="Channel" :items="getLeadChannels" :disabled="formLoading" hide-details outlined dense required></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="origin" label="Origin" :disabled="formLoading||!hasUserGotRole('marketing-team')" hide-details outlined dense required></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="gclid" label="GCLID" :disabled="formLoading||!hasUserGotRole('marketing-team')" hide-details outlined dense required></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="fbclid" label="FBCLID" :disabled="formLoading||!hasUserGotRole('marketing-team')" hide-details outlined dense required></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="msclkid" label="MSCLKID" :disabled="formLoading||!hasUserGotRole('marketing-team')" hide-details outlined dense required></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="referrer" label="Referrer" :disabled="formLoading" hide-details outlined dense required></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="save" :disabled="formLoading" :loading="formLoading">Save</v-btn>
        <v-btn color="primary" outlined small @click="close">cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import { mapGetters,mapActions,mapState } from "vuex";
  export default {
    props: {
      dialogOpen:{type:Boolean,default:false}
    },

    mixins: [ validationMixin ],

    validations: {
      lead_source: { required },
    },

    data() {
      return {
        lead_source: '',
        channel: '',
        origin: '',
        gclid: '',
        fbclid: '',
        msclkid: '',
        referrer: '',
        formLoading: false,
      }
    },

    computed: {
      ...mapState('leads',['currentLead']),
      ...mapGetters('leads',['getLeadSources','getLeadChannels']),
      ...mapGetters('globals',['hasUserGotRole']),

      leadSourceErrors() {
        const errors = [];
        if (!this.$v.lead_source.$dirty) return errors;
        !this.$v.lead_source.required && errors.push("Lead Source is required");
        return errors;
      }
    },

    watch: {
      dialogOpen(val) {
        if(val){
          this.lead_source = this.currentLead.source;
          this.channel = this.currentLead.channel;
          this.origin = this.currentLead.origin;
          this.referrer = this.currentLead.referrer;
          this.gclid = this.currentLead.gclid;
          this.fbclid = this.currentLead.fbclid;
          this.msclkid = this.currentLead.msclkid;
        }
      }
    },

    methods: {
      ...mapActions('leads',['updateLeadSource']),
      close() {
        this.$emit('close-dialog');
      },
      async save() {
        this.$v.$touch();
        if(!this.$v.$error){
          this.formLoading = true;
          let data = {
            id: this.currentLead.id,
            data: { 
              source: this.lead_source,
              channel: this.channel,
              origin: this.origin,
              referrer: this.referrer,
              gclid: this.gclid,
              fbclid: this.fbclid,
              msclkid: this.msclkid,
            }
          };
          try{
            await this.updateLeadSource({sentData: data});
            this.formLoading = false;
            this.close();
          }catch(error){
            this.formLoading = false;
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>
